import React, {useState} from 'react'
import {Navigate} from 'react-router-dom'

// Assets
import horseImage from '../assets/images/singup_horse.png'
import Logo from '../assets/images/logo.png'

// Components
import InputField from '../components/elements/InputField'
import Button from '../components/elements/Button'
import SocialMediaButtons from '../components/containers/SocialMediaButtons'

// API
import {authenticationService} from '../api'
// Hooks
import {useRecaptchaV2} from '../hooks/useRecaptchaV2'

function Signup() {
    const [redirect, setRedirect] = useState(false)
    const [errors, setErrors] = useState({})

    const {
        containerRef,
        token: recaptchaToken,
        reset: resetRecaptcha,
        isReady: isRecaptchaReady,
        recaptchaErrorOccurred,
    } = useRecaptchaV2()

    async function handleSubmit(e) {
        e.preventDefault()

        if (!isRecaptchaReady || !recaptchaToken) {
            return
        }

        setErrors({})

        const formElement = document.getElementById('signup-form')
        const formData = new FormData(formElement)
        formData.append('captcha_token', recaptchaToken)

        authenticationService.signup(formData)
        .then(response => {
            setRedirect(true)
        })
        .catch(error => {
            setErrors({...error})
            resetRecaptcha()
        })
    }

    if (redirect) {
        return <Navigate to='/thank-you' />
    }

    return (
        <div className="signup-page">
            <div className="signup-page__columns">
                <div className="signup-page__hero">
                    <img src={horseImage} alt="ChampionBred horse" />
                </div>
                <div className="signup-page__copy">
                    <div className="signup-copy__inner">
                        <h1 className="signup-copy__eyebrow">Welcome</h1>
                        <p className="signup-copy__title">Sign up without a credit card and <span>get 10 free TOKENS</span> to explore our platform.</p>
                        <div className="signup-copy__body">
                            <div className="signup-copy__note">
                                <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19.5 4.5L26.5 11.5L22 16L15 9Z" stroke="#272727" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M14 10.5L21 17.5L17 21.5L10 14.5Z" stroke="#272727" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M20.5 14.5L30.5 24.5" stroke="#272727" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M13 28H28" stroke="#272727" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M10.5 31H30.5" stroke="#272727" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                <div>
                                    <p className="signup-copy__note-title">Go to Catalogues and find our reports for each of the horses at the following auctions:</p>
                                    <ul className="signup-copy__list">
                                        <li>Magic Millions</li>
                                        <li>Inglis</li>
                                        <li>New Zealand Bloodstock</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="signup-highlight">
                            <div className="signup-highlight__icon">
                                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 2L14.4721 8.52786H21.4127L15.4703 12.6943L17.9424 19.2221L12 15.0557L6.05762 19.2221L8.52972 12.6943L2.58731 8.52786H9.52786L12 2Z" fill="white" stroke="white" strokeWidth="1.5" strokeLinejoin="round"/>
                                </svg>
                            </div>
                            <p>Proven performance — supported statistically and by previously released predictions. Unique approach.</p>
                        </div>
                    </div>
                </div>
                <div className="signup-page__form">
                    <div className="signup-form-card">
                        <img className="signup-form-card__logo" src={Logo} alt="ChampionBred" />
                        <form id="signup-form" onSubmit={handleSubmit}>
                            <div className="signup-form-card__row">
                                <InputField name="first_name" type="text" label="First Name" error={errors.first_name} class="signup-form-card__input" />
                                <InputField name="last_name" type="text" label="Last Name" error={errors.last_name} class="signup-form-card__input" />
                            </div>
                            <InputField name="email" type="email" label="Email" error={errors.email} class="signup-form-card__input" />
                            <InputField name="password" type="password" label="Password" error={errors.password} class="signup-form-card__input" />
                            <InputField name="password2" type="password" label="Repeat Password" error={errors.password2 || errors.non_field_errors || errors.detail} class="signup-form-card__input" />
                            <div className="signup-form-card__recaptcha-wrapper" style={{ marginTop: '12px' }}>
                                <div ref={containerRef} />
                            </div>
                            {recaptchaErrorOccurred && (
                            <div className="left input-field signup-form-card__input">
                                <p className="error">Unknown error. Please try again or contact <span style={{textDecoration: 'underline'}}>info@championbred.com.au</span></p>
                            </div>
                            )}
                            <Button text="Sign up" class="signup-form-card__submit" type="submit" inactive={!isRecaptchaReady || !recaptchaToken} />
                            <SocialMediaButtons type="sign up" />
                        </form>
                        <p className="signup-form-card__footer">
                            Already have an account?&nbsp;
                            <a className="link is-gold" href="/login">Log In</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Signup
